"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentItemToJSON = exports.FulfillmentItemFromJSONTyped = exports.FulfillmentItemFromJSON = exports.instanceOfFulfillmentItem = void 0;
var runtime_1 = require("../runtime");
var CostModel1_1 = require("./CostModel1");
/**
 * Check if a given object implements the FulfillmentItem interface.
 */
function instanceOfFulfillmentItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFulfillmentItem = instanceOfFulfillmentItem;
function FulfillmentItemFromJSON(json) {
    return FulfillmentItemFromJSONTyped(json, false);
}
exports.FulfillmentItemFromJSON = FulfillmentItemFromJSON;
function FulfillmentItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'lineItemId': !(0, runtime_1.exists)(json, 'line_item_id') ? undefined : json['line_item_id'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'campaignId': !(0, runtime_1.exists)(json, 'campaign_id') ? undefined : json['campaign_id'],
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel1_1.CostModel1FromJSON)(json['cost_model']),
    };
}
exports.FulfillmentItemFromJSONTyped = FulfillmentItemFromJSONTyped;
function FulfillmentItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'title': value.title,
        'line_item_id': value.lineItemId,
        'ad_account_id': value.adAccountId,
        'ad_set_id': value.adSetId,
        'campaign_id': value.campaignId,
        'cost_model': (0, CostModel1_1.CostModel1ToJSON)(value.costModel),
    };
}
exports.FulfillmentItemToJSON = FulfillmentItemToJSON;
